import { createAsyncThunk } from '@reduxjs/toolkit';

import { QuestionnaireService } from 'api';

export const getKYC = createAsyncThunk('questionnaire/getKYC', async () => {
	return await QuestionnaireService.getKYC();
});
